import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Local from '../../Local/Local';
import Image from '../../Image/Image';
import { providerLogoImagePathSelector } from '../../../redux/reducers/app/configuration';
import { useQueryProvider } from '../../../hooks/API/useQueryProviders';
import { getProviderLogoImagePath } from '../../../utils/imagePath';
import styles from './GameCardsLineProvider.module.css';

const GameCardsLineProviderTitle = ({ title, titleTemplate, providerId }) => {
  const imagePath = useSelector(providerLogoImagePathSelector);

  const { data } = useQueryProvider(providerId, {
    enabled:
      (Boolean(providerId) && titleTemplate && !title) ||
      (!titleTemplate && !title),
  });

  if (title && titleTemplate) {
    return <Local values={{ title }}>{titleTemplate}</Local>;
  }

  if (title && !titleTemplate) {
    return <Local>{title}</Local>;
  }

  const providerName = data?.translationKey ?? '';

  if (!title && titleTemplate) {
    return <Local values={{ title: providerName }}>{titleTemplate}</Local>;
  }

  return (
    <Image
      src={getProviderLogoImagePath(imagePath, providerId)}
      fallback={providerName}
      className={styles.logo}
    />
  );
};

GameCardsLineProviderTitle.propTypes = {
  title: PropTypes.string,
  titleTemplate: PropTypes.string,
  providerId: PropTypes.string,
};

export default memo(GameCardsLineProviderTitle);
